import { ReactNode } from 'react';

import { Typography, tokens } from '@cast/design-system';

type SettingsInfoCalloutProps = {
  children: ReactNode;
  variant?: 'info' | 'neutral';
};

export const SettingsInfoCallout = ({
  children,
  variant = 'info',
}: SettingsInfoCalloutProps) => {
  const isInfo = variant === 'info';

  return (
    <Typography
      variant="P12R"
      component="div"
      sx={{
        p: 12,
        borderRadius: '4px',
        backgroundColor: isInfo
          ? tokens.theme.bg.status.infoSubtle
          : tokens.theme.bg.status.neutralSubtle,
        color: isInfo
          ? tokens.theme.fg.status.onInfoSubtle
          : tokens.theme.fg.status.onNeutralSubtle,
        ...(isInfo && {
          border: '1px solid',
          borderColor: tokens.theme.border.status.infoSubtle,
        }),
        '& a': {
          color: 'inherit',
          textDecoration: 'underline',
        },
      }}
    >
      {children}
    </Typography>
  );
};
